import { CheckboxTable } from "components";
import React from 'react';

interface Props {
  label: string;
  checked: boolean;
  onToggle: () => void;
}

export const CheckboxRow = ({ label, checked, onToggle }: Props) => (
  <label className="checkbox-row" onClick={onToggle}>
    <CheckboxTable active={checked} />
    <p>{ label }</p>
  </label>
);